export const getAllCookies = (): { [key: string]: string } => {
	const cookies = document.cookie.split(';')
	const cookiesObject = cookies.reduce((obj: { [key: string]: string }, value) => {
		const [key, property] = value.split('=')
		obj[key.trim()] = property
		return obj
	}, {})
	return cookiesObject
}

export const getCookie = (name: string): string => {
	const allCookies = getAllCookies()
	return allCookies[name]
}
